import React from 'react'
import { Alert, Button, CircularProgress, Typography } from '@mui/material'
import AppDialog from '../dialog/AppDialog'

export default function DeleteRowsDialog({ open, title, message, warning, deleting, error, onClose, onConfirm }) {
    return (
        <AppDialog
            open={open}
            onClose={deleting ? undefined : onClose}
            title={title}
            maxWidth='sm'
            actions={
                <>
                    <Button disabled={deleting} onClick={onClose}>Cancel</Button>
                    <Button
                        color='error'
                        variant='contained'
                        disabled={deleting}
                        aria-busy={deleting}
                        startIcon={deleting ? <CircularProgress size={16} color='inherit' data-testid='delete-rows-spinner' /> : null}
                        onClick={onConfirm}>
                        {deleting ? 'Deleting...' : 'Delete'}
                    </Button>
                </>
            }>
            <Typography>{message}</Typography>
            {warning && <Alert severity='warning' sx={{ mt: 2 }}>{warning}</Alert>}
            {error && <Alert severity='error' sx={{ mt: 2 }}>{error}</Alert>}
        </AppDialog>
    )
}
